import React from 'react';
import MoneyballPositionsTable from './moneyballPositionsTable/moneyballPositionsTable';
const moneyballPositionsListReduxKey = '/hr/moneyball_positions';

export function MoneyballPositions() {
	return <MoneyballPositionsTable reduxKey={moneyballPositionsListReduxKey} />;
}
